var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "table-resize-reset sup-resize-stop resize-stop",
    class: [!_vm.right ? 'control-sidebar control-sidebar-dark wtree_right' : 'main-sidebar pull-left sidebar-primary wtree_left'],
    staticStyle: {
      "transition": "none",
      "margin-right": "50px",
      "background-color": "#323e44"
    },
    style: (_vm.widthChanger),
    attrs: {
      "id": !_vm.right ? 'right-sidebar' : 'sidebar-left'
    }
  }, [_c('section', {
    staticClass: "sidebar",
    staticStyle: {
      "padding": "0px"
    },
    style: ('margin-left:' + (!_vm.right ? '0px' : '50px') + ';')
  }, [_c('li', {
    staticClass: "header",
    style: ('z-index: 9999; list-style: none; color: #999; padding: 0px; margin-bottom: 2px; position: absolute;' + _vm.pos_string),
    attrs: {
      "id": "buttons.sup_resize_wrapper"
    }
  }, [(_vm.right) ? _c('dynButton', {
    attrs: {
      "configs": {
        ID: 'buttons.sup-resize',
        visible: true
      },
      "btnClasses": "sup-resize-start",
      "icon": _vm.$root.icons.h_resize,
      "styleObj": {
        'border-width': '2px',
        'border-color': '#999',
        'position': 'fixed',
        'top': '57px',
        'width': '28px',
        'height': '30px',
        'padding': '1px',
        'float': 'right',
        'cursor': 'w-resize',
        'background-color': '#666',
        'color': 'white'
      }
    },
    on: {
      "invisible": function($event) {
        _vm.hide('buttons.sup_resize_wrapper')
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.right) ? _c('div', {
    staticClass: "right-btn-wrapper",
    staticStyle: {
      "position": "fixed",
      "top": "50px"
    }
  }, [_c('dynButton', {
    attrs: {
      "configs": {
        ID: 'buttons.sup-resize',
        visible: true
      },
      "btnClasses": "sup-resize-start",
      "icon": _vm.$root.icons.h_resize,
      "styleObj": {
        'border-width': '2px',
        'border-color': '#999',
        'position': 'absolute',
        'width': '28px',
        'height': '30px',
        'padding': '1px',
        'float': 'right',
        'top': '7px',
        'cursor': 'w-resize',
        'background-color': '#666',
        'color': 'white'
      }
    },
    on: {
      "invisible": function($event) {
        _vm.hide('buttons.sup_resize_wrapper')
      }
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.content == 'Impiego') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "1px 0px",
      "border-bottom": "1px solid rgb(173, 180, 187)",
      "box-shadow": "rgb(243, 253, 255) 0px 1px 0px",
      "color": "#323e44 !important"
    }
  }, [_c('label', {
    staticStyle: {
      "padding-top": "8px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('use')))])]) : _vm._e(), _vm._v(" "), (_vm.content == 'Documenti') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "1px 0px",
      "border-bottom": "1px solid rgb(173, 180, 187)",
      "box-shadow": "rgb(243, 253, 255) 0px 1px 0px",
      "color": "#323e44 !important"
    }
  }, [_c('label', {
    staticStyle: {
      "padding-top": "8px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('document', 2)))])]) : _vm._e(), _vm._v(" "), (_vm.content == 'Anteprime') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "1px 0px",
      "border-bottom": "1px solid rgb(173, 180, 187)",
      "box-shadow": "rgb(243, 253, 255) 0px 1px 0px",
      "color": "#323e44 !important"
    }
  }, [_c('label', {
    staticStyle: {
      "padding-top": "8px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('preview', 2)))])]) : _vm._e(), _vm._v(" "), (_vm.content != 'Stampa') ? _c('div', {
    staticClass: "media",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('div', {
    staticClass: "media-body media-middle",
    staticStyle: {
      "height": "80px",
      "display": "inline"
    }
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header",
    staticStyle: {
      "color": "#999",
      "padding": "0px",
      "margin": "0px",
      "background-color": "inherit",
      "display": "list-item",
      "text-align": "center",
      "border-bottom": "none"
    }
  }, [_c('form', {
    staticClass: "sidebar-form row",
    staticStyle: {
      "border-style": "none",
      "display": "block"
    }
  }, [(_vm.activeComponent == 'Impiego' && _vm.$root.richiestaImpiego) ? _c('div', {
    staticClass: "col-xs-12 sidebar-text",
    staticStyle: {
      "padding": "0px",
      "font-size": "larger"
    }
  }, [_c('ul', {
    staticClass: "nav nav-pills f-s"
  }, [_c('li', {
    staticClass: "active",
    staticStyle: {
      "float": "none",
      "width": "100%",
      "padding": "0px"
    }
  }, [_c('a', {
    staticClass: "f-s-a",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.$root.richiestaImpiego.spi && _vm.$root.richiestaImpiego.spi != "" ? _vm.$root.richiestaImpiego.spi : _vm.$root.richiestaImpiego.cod) + ' - '))]), _vm._v(_vm._s(_vm.$root.richiestaImpiego.des))])])])]) : _c('div', {
    staticClass: "col-xs-12 sidebar-text",
    staticStyle: {
      "padding": "0px",
      "font-size": "larger"
    }
  }, [(_vm.trigger == null || _vm.trigger.length == 0) ? _c('ul', {
    staticClass: "nav nav-pills f-s"
  }, [(_vm.activeData && _vm.activeData.father) ? _c('li', {
    staticClass: "active",
    staticStyle: {
      "float": "none",
      "width": "100%",
      "padding": "0px"
    }
  }, [_c('a', {
    staticClass: "f-s-a",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.activeData.father.sid + ' - '))]), _vm._v(_vm._s(_vm.activeData.father.des))])]) : _vm._e()]) : _c('ul', {
    staticClass: "nav nav-pills f-s"
  }, [_c('li', {
    class: {
      'active': _vm.activeTab == 'father'
    },
    staticStyle: {
      "float": "right",
      "width": "100%",
      "padding": "0px"
    }
  }, [_c('a', {
    staticClass: "f-s-a",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleFather($event)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.activeData.father.sid + ' - '))]), _vm._v(_vm._s(_vm.activeData.father.des))])]), _vm._v(" "), _vm._l((_vm.trigger), function(child, index) {
    return _c('li', {
      key: index,
      class: {
        'active': _vm.activeTab == 'child' && _vm.activeChild == index
      },
      staticStyle: {
        "float": "right"
      },
      style: ({
        width: _vm.trigger_width
      })
    }, [_c('a', {
      staticClass: "f-s-a",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleChild(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(child.sid + ' - '))]), _vm._v(_vm._s(child.des))])])
  })], 2)])])])])])]) : _vm._e(), _vm._v(" "), _c(_vm.activeComponent, {
    tag: "components",
    attrs: {
      "activeData": _vm.activePropData,
      "mh": _vm.maxHeight,
      "isChild": _vm.activeTab == 'child'
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52b06088","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SupportSidebar.vue
// module id = 1452
// module chunks = 1